import {
  SET_ENTITIES, UNSET_ENTITIES,
} from '@/vuex/modules/entities/types/mutations';

import {
  DEFINE_ENTITIES, CLEAR_ENTITIES,
} from '@/vuex/modules/entities/types/actions';


export default {
  state: {
    entities: [],
  },
  getters: {
    entities: state => state.entities,
  },
  mutations: {
    [SET_ENTITIES](state, entities) {
      const entitiesObj = entities;
      Object.keys(entitiesObj).forEach((key) => {
        entitiesObj[key].neededFiles = entitiesObj[key].docs
          .reduce((total, obj) => total + obj.neededCount, 0);
      });
      state.entities = entitiesObj;
      localStorage.entities = JSON.stringify(entitiesObj);
    },
    [UNSET_ENTITIES](state) {
      state.entities = [];
      localStorage.removeItem('entities');
    },
  },
  actions: {
    [CLEAR_ENTITIES](context) {
      context.commit(UNSET_ENTITIES);
    },
    [DEFINE_ENTITIES](context, payload) {
      context.commit(SET_ENTITIES, payload.entities || []);
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/entities/index.js